import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class OeLoadPlanListItem extends SearchModelBase {
    id: number = 0;
    containerNo: string = '';
    conType: string = '';
    refNo: string = '';
    bookingNo: string = '';
    mblNo: string = '';
    agentSName: string = '';
    vessel: string = '';
    etd: string | null = null;
    fromEtd: string | null = null;
    toEtd: string | null = null;
    cutOffDate: string | null = null;
    fromCutOffDate: string | null = null;
    toCutOffDate: string | null = null;
    loadingPort: string = '';
    lpU2Date: string | null = null;
    fromLPU2Date: string | null = null;
    toLPU2Date: string | null = null;
    lpU2ID: string = '';
    u1ID: string = '';
    voyage: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true, visible: true, sortable: false}),
        XCol.Create({ col: 1, text: 'Container #', width: 100, dataIndex: 'containerNo', defaultColumnFocus : true}),
        XCol.Create({ col: 2, text: 'Type', width: 60, dataIndex: 'conType'}),
        XCol.Create({ col: 3, text: 'Ref. #', width: 100, dataIndex: 'refNo'}),
        XCol.Create({ col: 4, text: 'Booking #', width: 120, dataIndex: 'bookingNo'}),
        XCol.Create({ col: 5, text: 'MBL #', width: 100, dataIndex: 'mblNo'}),
        XCol.Create({ col: 6, text: 'Agent', width: 120, dataIndex: 'agentSName'}),
        XCol.Create({ col: 7, text: 'Cargo Cutoff', width: 75, dataIndex: 'cutOffDate', type: XCol.XCellType.Date}),
        XCol.Create({ col: 8, text: 'Vessel Name', width: 120, dataIndex: 'vessel'}),
        XCol.Create({ col: 9, text: 'Voyage #', width: 80, dataIndex: 'voyage'}),
        XCol.Create({ col: 10, text: 'Loading Port', width: 80, dataIndex: 'loadingPort'}),
        XCol.Create({ col: 11, text: 'ETD', width: 75, dataIndex: 'etd', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 12, text: 'Create by', width: 80, dataIndex: 'u1ID'}),
        XCol.Create({ col: 13, text: 'Update Date', width: 100, dataIndex: 'lpU2Date', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 14, text: 'Update by', width: 80, dataIndex: 'lpU2ID'}),
    ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: OeLoadPlanListItem.prototype.id, orderByAscending: false };

    public static formatData(data: OeLoadPlanListItem[]) {
        return data.map((d: OeLoadPlanListItem) => ({
          ...d,
        }));
    }
    public static MapOeSearchFields: {[key: string]: {[key: string]: string}} = {
        etd: {from: 'fromEtd', to: 'toEtd'},
        lpU2Date: {from: 'fromLPU2Date', to: 'toLPU2Date'},
        cutOffDate: {from: 'fromCutOffDate', to: 'toCutOffDate'},
    }
}
